import { z } from 'zod'

/**
 * Where to send the user once they are signed in.
 *
 * The target is carried across every step of the sign-in flow — password, TOTP, a forced password
 * change — so someone who followed a link to a specific loan lands on that loan rather than on the
 * dashboard, however many challenges stood in the way.
 *
 * The value is only ever accepted as an application-internal path. A `redirect` that names another
 * origin — or a protocol-relative `//host` that a browser reads as one — is discarded rather than
 * followed: an open redirect on a sign-in page is how a convincing credential-harvesting link gets
 * built out of a legitimate banking domain.
 */
const internalPath = z
  .string()
  .refine((value) => value.startsWith('/') && !value.startsWith('//'), {
    message: 'Only in-application paths are accepted.',
  })

export const authSearchSchema = z.object({
  redirect: internalPath.optional().catch(undefined),
})

export type AuthSearch = z.infer<typeof authSearchSchema>
